"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.swedenTranslations = void 0;
var _types = require("../../../types");
const swedenTranslations = exports.swedenTranslations = {
  [_types.ErrorPageTranslationKey.headline]: ' Förlåt!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Tillbaka',
  [_types.ErrorPageTranslationKey.text]: ' Denna sida fungerar inte för tillfället',
  [_types.ErrorPageTranslationKey.notFound]: 'Sidan du letar efter kan tyvärr inte hittas',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Sidan du försöker nå har begränsad åtkomst och alla kriterier uppfylldes inte.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Vänligen kontakta Oriflames supportteam via e-post:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'Den begärda webbadressen avvisades!'
};
